import { Component } from "react";
import INF from "../components/book/Fragments/INF";
import TAB from "../components/book/Fragments/TAB";
import { ButtonsRight } from "./UI";

const Components = {
  TAB: TAB,
  INF: INF
};

export interface ResourceType {
  name: string
  abreviation: string
  icon: string
  class: string
}

export interface Obj {
  id: number
  url: string
  name: string
  title?: string
  description?: string
}

export interface Fragment {
  id: number
  type: FragmentType
  title: string
  text: string
  text2: string
  img: string
  img2: string
  urlObj: string
  urlObj2: string
  objs: Obj[]
  idxSection?: number
  name?: string
  subtitle?: string
  autor?: string;
  creditos?: string | null;
}

export enum FragmentType {
  TABLE = 'TABLE',
  INF = 'INF',
  OVA = 'OVA',
  GAL = 'GAL',
  TXT = 'TXT',
  PRC = 'PRC',
  VIDEO = 'VIDEO',
  PERFIL = 'PERFIL',
  LAB = 'LAB'
}

export const FragmentResourceTypes = [
  'TABLE',
  'INF',
  'OVA',
  'GAL',
  'PRC',
  'VIDEO',
  'PERFIL',
  'LAB'
]

export interface SubSection {
  id: number
  title: string
  description: string
  abstract: string
  text: string
  cover?: string
  urlFicha?: string
  audio?: string
  audio2?: string
  fragments: Fragment[];
}


export interface Section {
  id: number
  title: string
  description: string
  abstract: string
  text: string
  subsections?: SubSection[]
  cover?: string
  trivia?: number
  podcastURL?: string;
}

export interface Autor {
  fullName: string
  name: string
  lastname: string
  email: string;
  profesion?: string | null;
  afiliacion?: string | null;
  masInfo?: string | null;
}


export interface Publication {

  id: number
  title: string
  subtitle?: string
  coverImg: string
  credits: string
  creditsImg: string
  creditsLogo?: string
  issn?: string
  doi?: string
  publicationDate?: string
  editorName?: string
  editorURL?: string
  asistenteKey?: string;
  numero?: string;
  periodo?: string;
  catalogoImg?: string;

  language?: string
  year?: string
  category?: string
  subcategory?: string
  applicationAreas?: string
  urlVirtualpro?: string

  sections: Section[]
  authors?: Autor[]
  copyRight?: number | null;
  copyRightDetail?: {
    copyright: string;
    text?: string | null;
    img: string;
    url: string;
    abbreviation: string;
  } | null;
  currentSection: number
  autorImg?: string;
  autorVideo?: string;
}


export interface PublicationWrapper {
  data: {
    publication?: Publication
  }
}


export interface PublicationHelp {
  title: string
  text: string
}


export interface FragmentProps {
  fragment: Fragment
  openButtons: ButtonsRight
  setOpenButtons: (state: ButtonsRight) => void
  rawMode?: boolean
  subsectionId?: number;
  showTitle?: boolean;
}

export type typeLibro = 'libro' | 'revista';

export type optionTypeLibro = {
  key: typeLibro;
  directory: string;
  fileName: string;
  route: string;
};

export const typeLibrosOptions: optionTypeLibro[] = [
  { key: 'libro', directory: 'publications', fileName: 'publication', route: 'libros' },
  { key: 'revista', directory: 'journals', fileName: 'journal', route: 'revista' },
];

export const findTypeOption = (typeLibro: typeLibro): optionTypeLibro | undefined => {
  return typeLibrosOptions.find(option => option.key === typeLibro);
};